import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { get, post } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";

import { errorMessage } from "../CommonFunctions";
import {
  POST_GetEmployeeDDLList,
  POST_GetReportChatHistoryExport,
  POST_GetReportChatHistoryList,
} from "../../../helpers/url_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";

const ChatHistory = () => {
  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(true);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("asc");

  const [isReset, setIsReset] = useState(false);

  const [chatHistoryList, setChatHistoryList] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const yesNoOptions = [
    { label: "All", value: -1 },
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      FromDate: new Date(),
      ToDate: new Date(),
      SenderIDEncrypted: "",
      ReceiverIDEncrypted: "",
      Attachment: -1,
      DeleteMessageStatus: 0,
      Search: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      Search,
      FromDate,
      ToDate,
      SenderIDEncrypted,
      ReceiverIDEncrypted,
      Attachment,
      DeleteMessageStatus,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    getEmployeeDDL();
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getEmployeeDDL = async () => {
    setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          const employeeOptions = [
            ...response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName + " (" + item.DepartmentName + ")",
              value: item.EmployeeIDEncrypted,
            })),
          ];
          setEmployeeOptions(employeeOptions);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SenderIDEncrypted: SenderIDEncrypted,
      ReceiverIDEncrypted: ReceiverIDEncrypted,
      Attachment: Attachment,
      DeleteMessageStatus: DeleteMessageStatus,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    };

    await post(POST_GetReportChatHistoryList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setChatHistoryList(response?.List);

        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      FromDate: new Date(),
      ToDate: new Date(),
      SenderIDEncrypted: "",
      ReceiverIDEncrypted: "",
      Attachment: -1,
      DeleteMessageStatus: 0,
      Search: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      Search: Search,
      SenderIDEncrypted: SenderIDEncrypted,
      ReceiverIDEncrypted: ReceiverIDEncrypted,
      Attachment: Attachment,
      DeleteMessageStatus: DeleteMessageStatus,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    post(POST_GetReportChatHistoryExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Chat History</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  title="Go to Reports"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa-solid fa-table" /> Back to Report Menu
                </button>

                <button
                  type="button"
                  title="Reset"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>{" "}
                  Reset
                </button>
                <button
                  type="button"
                  title="Filter"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                <Link
                  title="Export Report"
                  className="btn btn-outline-primary btn-sm"
                  onClick={exportReport}
                >
                  <i className="fa-solid fa-file-excel" /> Export Report
                </Link>
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={3}>
                          <Field
                            label="Search"
                            name="Search"
                            placeholder={"Search here..."}
                            component={CustomInput}
                            autoFocus={isFilterExpanded}
                          />
                        </Col>

                        <Col lg={3}>
                          <Field
                            label="Sender"
                            name="SenderIDEncrypted"
                            placeholder={"Select Sender"}
                            options={employeeOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                          />
                        </Col>

                        <Col lg={3}>
                          <Field
                            label="Receiver"
                            name="ReceiverIDEncrypted"
                            placeholder={"Select Receiver"}
                            options={employeeOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                          />
                        </Col>

                        <Col lg={3}>
                          <Field
                            label="Attachment"
                            name="Attachment"
                            placeholder={"Select Attachment"}
                            options={yesNoOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>

                        <Col lg={3}>
                          <Field
                            label="Deleted Message"
                            name="DeleteMessageStatus"
                            placeholder={"Select Delete Message"}
                            options={yesNoOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={3}>
                          {/* <label className="mb-1">Date</label> */}
                          <div className="d-flex">
                            <Field
                              label="From Date"
                              name="FromDate"
                              placeholder={"From Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                            />
                            <div>&nbsp;</div>
                            <Field
                              label="To Date"
                              name="ToDate"
                              placeholder={"To Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                                minDate: FromDate,
                              }}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                className="btn btn-primary btn-sm mb-1"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i
                                  className="fa fa-search"
                                  aria-hidden="true"
                                ></i>
                                {"  "} Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div
                id="ChatHistory-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="ChatHistory-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th style={{ width: "3%" }}>Sr No</th>
                      <th style={{ width: "40%" }}>Chat Message</th>
                      <th style={{ width: "20%" }}>Chat File Name</th>
                      <th style={{ width: "11%" }}>Chat Date</th>
                      <th style={{ width: "13%" }}>Sender Name</th>
                      <th style={{ width: "13%", textAlign: "left" }}>
                        Receiver Name
                      </th>
                      {/* <th style={{ width: "13%" }}>Sender Department</th>
                      <th style={{ width: "13%", textAlign: "left" }}>
                        Receiver Department
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {chatHistoryList?.length > 0 ? (
                      chatHistoryList?.map((item, indx) => (
                        <tr key={indx}>
                          <td
                            className="text-center"
                            style={{ verticalAlign: "top" }}
                          >
                            {item?.RowNo}
                          </td>
                          <td
                            style={{
                              //   cursor: "pointer",
                              //   textAlign: "left",
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                            //className="popupOverlayReports"
                          >
                            {item?.ChatMessage}
                            {/* <OverlayTrigger
                              trigger={["hover", "focus"]}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {item?.ChatMessage}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>{item?.ChatMessage}</span>
                            </OverlayTrigger> */}
                          </td>

                          <td
                            style={{
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item.ChatFileName} &nbsp;
                            {item.ChatFileName ? (
                              <Link
                                to="#"
                                className="fs-14"
                                onClick={() => {
                                  window.open(item?.ChatFilePath, "_blank");
                                }}
                              >
                                <i className="fa fa-download"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                          </td>
                          <td
                            style={{
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item.ChatDate}
                          </td>

                          <td
                            style={{
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item.SenderName}
                          </td>
                          <td
                            style={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item.ReceiverName}
                          </td>
                          {/* 
                          <td
                            style={{
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item.SenderDepartmentName}
                          </td>
                          <td
                            style={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item.ReceiverDepartmentName}
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default ChatHistory;
